import { render, staticRenderFns } from "./LogisticOrder.vue?vue&type=template&id=4ae6a662&"
import script from "./LogisticOrder.vue?vue&type=script&lang=js&"
export * from "./LogisticOrder.vue?vue&type=script&lang=js&"
import style0 from "./LogisticOrder.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LogisticOrder.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports